"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ASSINATURA_DIGITAL = {
  ALGORITMO: {
    SHA256: "2.16.840.1.101.3.4.2.1",
    SHA512: "2.16.840.1.101.3.4.2.3"
  },
  AUTHORIZATION_CODE: "authorization-code",
  AUTHORIZATION_TOKEN: "authorization-token",
  CODE_VERIFIER: "code-verifier",
  CONFIG: "config",
  ESCOPO: {
    MULTI_SIGNATURE: "multi_signature",
    SIGNATURE_SESSION: "signature_session",
    SINGLE_SIGNATURE: "single_signature"
  },
  FORMATO: {
    CMS: "CMS",
    RAW: "RAW"
  },
  STATE: "stt-app-state",
  NAO_ASSINAR: "stt-assinatura-digital-nao-assinar"
};
var _default = ASSINATURA_DIGITAL;
exports["default"] = _default;